<template>
    <div class="chat-mensagens-lista scroll-y scroll-y-transition-enter-active overflow-x-hidden px-2" v-chat-scroll>
       <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'ChatMensagemContainer'
}
</script>

<style scoped lang="stylus">
    .chat-mensagens-lista
        background-color white
        height auto !important
        min-height 150px !important
        max-height calc(100vh - 450px) !important


</style>